import { render, staticRenderFns } from "./TabReservations.vue?vue&type=template&id=f6937f9a&"
import script from "./TabReservations.vue?vue&type=script&lang=ts&"
export * from "./TabReservations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f6937f9a', component.options)
    } else {
      api.reload('f6937f9a', component.options)
    }
    module.hot.accept("./TabReservations.vue?vue&type=template&id=f6937f9a&", function () {
      api.rerender('f6937f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/TabsModals/Reservations/TabReservations.vue"
export default component.exports